<style scoped>

    .img-pop {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 70%;
        margin-left: -35%;
        margin-top: -30%;
        border: 0 solid #D3D3D3;
        border-radius: 10px;
        z-index: 100;
        background: #fff;
    }

    .img-pop p {
        text-align: center;
        padding: 20px 0;
    }

    .img-pop input {
        display: inline-block;
        vertical-align: middle;
        width: 68%;
        height: 46px;
        border: none;
        outline: none;
        background: transparent;
        border-right: 1px solid #D3D3D3;
        padding-left: 5px;
    }

    .img-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .6);
        z-index: 99;
    }

    .code-wrap {
        border: 1px solid #D3D3D3;
        margin: 0 15px 15px;
        border-radius: 4px;
        height: 48px;
    }

    .btn-wrap {
        text-align: center;
        padding-bottom: 15px;
    }

    .btn-wrap span {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        color: #D9A378;
    }

    .img-code-btn {
        display: inline-block;
        vertical-align: middle;
        width: 28%;
        overflow: hidden;
        text-align: center;
    }

    .img-code-btn img {
        width: 90px;
        height: 25px;
        margin-left: -5px;
    }

    @media screen and (min-width: 640px) {
        .img-pop {
            margin-top: -5%;
        }
    }

</style>
<template>
    <div>
        <div class="img-pop" v-show="show">
            <p>请输入验证码</p>
            <div class="code-wrap">
                <input type="text" v-model="code">
                <span class="img-code-btn" @click="getImg"><img :src="imgCode"></span>
            </div>
            <div class="btn-wrap">
                <span class="pop-btn" @click="getCode">确定</span>
            </div>
        </div>
        <div class="img-mask" v-show="show"></div>
    </div>
</template>
<script>
    export default {
        name: 'imgCode',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            phone: Number,
            codeType: Number
        },
        data() {
            return {
                code: '',
                codeKey: '',
                imgCode: '',
                isPost: true,
                calculationTime: 60
            }
        },
        watch: {
            show: function (val) {
                if (val == true) {
                    this.code = ''
                    this.getImg()
                }
            }
        },
        methods: {
            getCodeKey(res) {
                //获取图形验证码
                let data = res.body
                if (data.retcode == 0) {
                    this.codeKey = data.result
                    this.imgCode = JAVA_SERVER + 'atourlife/verifyCode/getCodeImage?codeKey=' + data.result + '&appVer=1.4.0&channelId=3000001&platType=3'
                } else {
                    toast.showToast(data.retmsg)
                }
            },
            getImg() {
                this.$http.post(JAVA_SERVER + 'atourlife/verifyCode/getCodeKey', {}).then(this.getCodeKey)
            },
            getCode() {
                //获取短信验证码
                if (!this.phone) {
                    toast.showToast("请输入手机号！")
                    return false
                } else if (!(/^1[3|4|5|7|8][0-9]{9}$/).test(this.phone)) {
                    toast.showToast("手机号格式不正确！")
                    return false
                } else if (!this.code) {
                    toast.showToast("请输入验证码！")
                    return false
                }
                localStorage.setItem("phoneNum", this.phone)
                this.inspectTime()
                this.clickGetTime()
                let param = {
                    phoneNum: this.phone,
                    code: this.code,
                    codeKey: this.codeKey,
                    type: this.codeType
                }
                this.$http.post(JAVA_SERVER + 'atourlife/verifyCode/getVerifyCodeByTypeForH5', param).then(this.getVerifyCodeByType)
            },
            getVerifyCodeByType(res) {
                let data = res.body
                if (data.retcode == 0) {
                    this.$emit('showOff')
                    toast.showToast("发送成功！")
                } else {
                    toast.showToast(data.retmsg)
                }
            },
            inspectTime(isAddTime) {
                var startTime = localStorage.getItem("startTime")
                var nowTime = new Date().getTime()
                var differ = parseInt((nowTime - startTime) / 1000) //时间差
                if (differ > this.calculationTime && !isAddTime) {
                    localStorage.setItem("startTime", new Date().getTime())
                } else if (differ < this.calculationTime) {
                    this.calculationTime = this.calculationTime - differ
                    return true
                }
                return false
            },
            clickGetTime() {
                var time = this.calculationTime
                var code = $('.msg')
                if (this.isPost) {
                    this.isPost = false
                    code.addClass("msg_active");
                    var timer = setInterval(function () {
                        time--;
                        code.html(time + "秒")
                        if (time == 0) {
                            clearInterval(timer)
                            code.html("重新获取")
                            this.code = ''
                            this.calculationTime = 60
                            localStorage.setItem("startTime", null)
                            this.isPost = true
                            code.removeClass("msg_active")
                        }
                    }, 1000)
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                if (this.inspectTime(true)) {
                    this.phone = localStorage.getItem("phoneNum")
                    this.clickGetTime()
                }
            })
        }
    }
</script>


// WEBPACK FOOTER //
// imgCode.vue?c7cd4a7c